/* 🤖 this file was generated by script */
export const wiconMerge = {
  name: 'merge',
  data: `<svg viewBox="0 0 20 21"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 16.75v-7a1 1 0 00-1-1h-4.5v-4.5a1 1 0 00-1-1h-7a1 1 0 00-1 1v7a1 1 0 001 1h4.5v4.5a1 1 0 001 1h7a1 1 0 001-1z"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10 8.75h-.75a1 1 0 00-1 1v.75M10 12.25h.75a1 1 0 001-1v-.75"/></svg>`,
};
